<template>
  <div class="tkListLoading">
    <div
      v-for="item in listNum"
      :key="item"
      class="tkListLoading_filter"
    >
      <tk-skeleton-loader
        class="tkListLoading_filterTile"
      />
    </div>
  </div>
</template>

<script>
import { TkSkeletonLoader } from '@ota-frontend/ui'
export default {
  name: 'TkListLoading',
  components: {
    TkSkeletonLoader,
  },
  props: {
    listNum: {
      type: Number,
      default: 10,
    },
  },
}
</script>

<style>
.tkListLoading_filterTile {
  height: 180px;
  width: 100%;
  margin-bottom: 10px;
}
</style>
